import { z } from 'zod';

import dayjs from '@/js/libs/dayjs';

import type { ForecastSearchParameters } from 'src/types.ts';
import { ForecastSearchKey } from 'src/types.ts';

export const tomorrow = dayjs(new Date()).utc().startOf('day').add(1, 'day');

export enum MediaType {
  ANALOG = 'ANALOG',
  DIGITAL = 'DIGITAL',
}

export const forecastRouterSearchParamsSchema = z.object({
  [ForecastSearchKey.SEARCH]: z.custom<ForecastSearchParameters>().optional(),
});
